import React, { useState, useEffect } from 'react';
import { Stepper } from'@shared/components/Stepper';
import { TransferDetailsStep } from'./stepComponents/TransferDetailsStep';
import { ReviewSubmitStep } from'./stepComponents/ReviewSubmitStep';
import { useNavigate } from'react-router-dom';
import { ChevronRight, ArrowLeft } from'lucide-react';
import { PageHeader } from'@shared/components/PageHeader';
import { SimpleSuccessScreen } from '@shared/components/SimpleSuccessScreen';
import { getRemoteUtilityId } from '@shared/utils/getUtilityId';
import { useTranslation } from 'react-i18next';
import { ActiveAccountBanner } from '../../../../shared/components/ActiveAccountBanner';

export const CreateTransfer = () => {
 const { t } = useTranslation();
 const navigate = useNavigate();
 const [isSubmitted, setIsSubmitted] = useState(false);
 
 useEffect(() => {
  return () => {
   localStorage.removeItem('transfer-request-draft');
  };
 }, []);
 
 const steps = [
 {
  title: t("Transfer Details"),
  slug:"transfer-details",
  component: <TransferDetailsStep remoteUtilityId={getRemoteUtilityId()} storageKey="transfer-storage"/>,
  optional: false,
  infoTitle: t("Transfer Details"),
  infoDescription: t("Fill in the transfer details."),
 },
 {
  title: t("Review & Submit"),
  slug:"review-submit",
  component: <ReviewSubmitStep 
  remoteUtilityId={getRemoteUtilityId()} 
  storageKey="transfer-storage"
  stopTracking={() => {}}
  fileObjects={[]}
  fileMetadata={[]}
  documentsFormData={{}}
  />,
  optional: false,
  infoTitle: t("Review & Submit"),
  infoDescription: t("Review your request details and submit."),
 },
 ];

 return (
 <div className="p-6">
  <div className="mb-6">
   <PageHeader 
    title={t("Create Transfer Request")} 
    subtitle={t("Follow the steps below to submit a new transfer request")}
    icon={ArrowLeft} 
    onIconClick={() => navigate('/dashboard/requests')} 
   />
   <ActiveAccountBanner />
  </div>
  
  {!isSubmitted ? (
   <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 md:p-8">
    <Stepper
       steps={steps}
       onStepChange={() => {}}
       onValidation={async () => ({ isValid: true })}
       onComplete={() => setIsSubmitted(true)}
       enableApiSave={false}
       saveOnStepChange={true}
       trackDirtyState={true}
       autoSave={true}
       persistProgress={true}
       storageKey="transfer-request-draft"
       allowSkip={true}
       showDraftResume={true}
    />
   </div>
  ) : (
   <SimpleSuccessScreen
    title={t("Transfer Request Submitted!")}
    ticketId={`TRF-${new Date().getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`}
    onPrimaryClick={() => navigate('/dashboard/requests')}
    onSecondaryClick={() => {
      setIsSubmitted(false);
      window.location.reload();
    }}
   />
  )}
 </div>
 );
};
